import { render, staticRenderFns } from "./NavBarLinks.vue?vue&type=template&id=35b3a53e&"
import script from "./NavBarLinks.vue?vue&type=script&lang=js&"
export * from "./NavBarLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports